import { warning, type MetricWarning } from './contracts';

/** SPEC-008 §64 — human-readable copy kept alongside the canonical codes. */
export const missingInput = (message = 'A required input is missing.', refs?: readonly string[]): MetricWarning =>
  warning('missing_input', message, refs);

export const divisionByZero = (message = 'The denominator is zero.', refs?: readonly string[]): MetricWarning =>
  warning('division_by_zero', message, refs);

export const incompleteCostBasis = (
  message = 'Some cost inputs are missing; this total understates the real cost.',
  refs?: readonly string[],
): MetricWarning => warning('incomplete_cost_basis', message, refs);

export const unallocatedFlow = (
  message = 'Outgoing conversions sum to less than 100%; some flow is unaccounted for.',
  refs?: readonly string[],
): MetricWarning => warning('unallocated_flow', message, refs);

export const overallocatedFlow = (
  message = 'Outgoing conversions sum to more than 100%.',
  refs?: readonly string[],
): MetricWarning => warning('overallocated_flow', message, refs);

export const partialMerge = (
  message = 'Some incoming flows are unknown; this total is partial, not complete.',
  refs?: readonly string[],
): MetricWarning => warning('partial_merge', message, refs);

export const cycleRequiresManualAnchor = (
  message = 'This value depends on a cycle and needs a manual anchor to resolve.',
  refs?: readonly string[],
): MetricWarning => warning('cycle_requires_manual_anchor', message, refs);

export const ambiguousMetricRole = (
  message = 'This node’s role in this aggregate is ambiguous; configure it explicitly.',
  refs?: readonly string[],
): MetricWarning => warning('ambiguous_metric_role', message, refs);

export const unsupportedMetric = (
  message = 'This metric is not supported for this node type.',
  refs?: readonly string[],
): MetricWarning => warning('unsupported_metric', message, refs);
